import BreadcrumbSectionImplementation from '../implementation/sections/BreadcrumbSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiBreadcrumbSectionDTO,
  BreadcrumbSectionDTO,
} from '@lib/strapi/dtos/components/sections/breadcrumbSection.dto';

const BreadcrumbSection = (props: ComponentProps<BreadcrumbSectionDTO>) => {
  return <BreadcrumbSectionImplementation {...props}></BreadcrumbSectionImplementation>;
};

export default BreadcrumbSection;
